<template>
  <Panel title="组件配置">

    <el-form
      ref="CertForm"
      label-position="top"
      :rules="certRules"
      :model="value"
    >
       <el-row>CertEncryptConfigEditor.vueCertEncryptConfigEditor.v
        <el-col :span="12">
          <el-form-item label="数据中心根证书" prop="rootCertDir">
            <el-input v-model="value.rootCertDir"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </Panel>
</template>
<script>

// import CommonApi from '@/api/Common';
export default {
  props: {
    value: { type: Object, default: () => {} },
    uuid: { type: String, default: '' },
  },
  data: () => ({
    data: '',
    mouldData: '',
    loading: false,
    certRules: {
      rootCertDir: [
        {
          message: '数据证书根证书路径',
          trigger: 'blur',
          required: true,
        },
      ],

    },
  }),
  created() {
    this.$set(this.value, 'rootCertDir', this.value['rootCertDir']);
  },
  watch: {},
  mounted() {},
  methods: {
    validate() {

        return this.$refs.CertForm.validate();

    },
    init() {},
    fmt() {
      try {
        let json = JSON.parse(this.data);
        this.data = JSON.stringify(json, '  ', 4);
      } catch (e) {
        this.$message.warning('JSON格式非法');
        this.$refs.input.focus();
      }
    },
    // async template() {
    //   if (!this.uuid) {
    //     return;
    //   }
    //   try {
    //     this.loading = true;
    //     let respData = await CommonApi.getJsonMould(this.uuid);
    //     this.mouldData = respData.jsonMould || '{}';
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // 设备名称切换触发
    // handleDeviceNameChange() {
    //   this.value.encryption = '';
    //   this.value.userConfig = '';
    //   this.value.signKeyIndex = '';
    //   this.value.ukeyPassword = '';
    //   this.value.userCertDir = '';
    //   this.value.hsmType = '';
    //   this.$refs.HSMForm.clearValidate();
    //   this.$refs.USBKeyForm.clearValidate();
    // },
  },
};
</script>

<style scoped></style>
